import { render, staticRenderFns } from "./operation-board-index.vue?vue&type=template&id=36e592bc&scoped=true&"
import script from "./operation-board-index.vue?vue&type=script&lang=js&"
export * from "./operation-board-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e592bc",
  null
  
)

export default component.exports